/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const VehicleSearchStatus = {
    Pending: 'pending',
    Complete: 'complete',
    Error: 'error'
} as const;
export type VehicleSearchStatus = typeof VehicleSearchStatus[keyof typeof VehicleSearchStatus];


export function instanceOfVehicleSearchStatus(value: any): boolean {
    for (const key in VehicleSearchStatus) {
        if (Object.prototype.hasOwnProperty.call(VehicleSearchStatus, key)) {
            if (VehicleSearchStatus[key as keyof typeof VehicleSearchStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function VehicleSearchStatusFromJSON(json: any): VehicleSearchStatus {
    return VehicleSearchStatusFromJSONTyped(json, false);
}

export function VehicleSearchStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): VehicleSearchStatus {
    return json as VehicleSearchStatus;
}

export function VehicleSearchStatusToJSON(value?: VehicleSearchStatus | null): any {
    return value as any;
}

export function VehicleSearchStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): VehicleSearchStatus {
    return value as VehicleSearchStatus;
}

